import Service from '../../services';

export const getListOffers = async params => {
  const response = await Service.isnGet(`/api/apartment/list-offers${params}`, res => res);
  return response;
};

export const getListTypeTerm = async params => {
  const response = await Service.isnGet(`/api/filters/get-long-short${params}`, res => res);
  return response;
};